/* ============================================================
   SORRY NONNA - Idle sweeping nonnas (#74)
   Let a page go idle and nonnas peek in from an edge, hop-walk to a
   random spot, then sweep with slow deliberate frames + dust puffs.
   The moment any activity happens they flash a "!", startle and
   scatter off-screen. Rendered by snippets/idle-nonnas.liquid.
   Desktop-only by default; fully disabled for reduced-motion.
   ============================================================ */
(function () {
  "use strict";

  var root = document.getElementById("idle-nonnas");
  if (!root) { return; }

  // Never run for reduced-motion; skip touch / small screens unless opted in.
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) { return; }
  var mobileOk = root.getAttribute("data-mobile") === "1";
  var coarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
  if (!mobileOk && (coarse || window.innerWidth < 768)) { return; }

  var STANDING = root.getAttribute("data-standing");
  var SWEEP = (root.getAttribute("data-sweep") || "").split(",").filter(Boolean);
  var DELAY = Math.max(2000, (parseFloat(root.getAttribute("data-delay")) || 10) * 1000);
  var COUNT = Math.max(1, Math.min(8, parseInt(root.getAttribute("data-count"), 10) || 4));
  if (!STANDING || !SWEEP.length) { return; }

  // ping-pong the sweep frames (1,2,3,2) so the broom arcs across and back
  var FRAMES = SWEEP.concat(SWEEP.slice(1, -1).reverse());

  // preload so the first appearance is smooth
  [STANDING].concat(SWEEP).forEach(function (u) { var im = new Image(); im.src = u; });

  var nonnas = [];
  var spawnTimers = [];
  var active = false;
  var activeCount = COUNT;
  var lastActivity = Date.now();

  function setX(el, x) { el.style.transform = "translateX(calc(" + Math.round(x) + "px - 50%))"; }
  function raf2(fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); }

  function goIdle() {
    if (active || document.hidden) { return; }
    active = true;
    // fewer on narrow screens so they never crowd (roughly one per 170px of width)
    activeCount = Math.max(1, Math.min(COUNT, Math.floor(window.innerWidth / 170)));
    // trickle them in one at a time, ~1-2s apart, so they don't all appear at once
    var acc = 0;
    for (var i = 0; i < activeCount; i++) {
      spawnTimers.push(setTimeout(spawn, acc, i));
      acc += 900 + Math.random() * 1100;
    }
  }

  function spawn(i) {
    if (!active) { return; }
    var vw = window.innerWidth;
    var fromLeft = Math.random() < 0.5;
    var mirror = Math.random() < 0.5;

    var el = document.createElement("div");
    el.className = "idle-nonna";
    el.style.setProperty("--nonna-scale", (0.86 + Math.random() * 0.3).toFixed(2));

    var body = document.createElement("div");
    body.className = "idle-nonna__body";

    var img = document.createElement("img");
    img.src = STANDING;
    img.alt = "";
    img.draggable = false;
    if (mirror) { img.style.transform = "scaleX(-1)"; }

    body.appendChild(img);
    el.appendChild(body);
    root.appendChild(el);

    var margin = Math.min(110, Math.round(vw * 0.13));
    var slot = (vw / (activeCount + 1)) * (i + 1);
    var jitter = Math.min(75, vw * 0.12);
    var targetX = Math.max(margin, Math.min(vw - margin, slot + (Math.random() * jitter * 2 - jitter)));
    var offX = fromLeft ? -220 : vw + 220;
    var peekX = fromLeft ? 12 : vw - 12;

    // vertical placement: mostly near the floor, occasionally higher up the page
    var vh = window.innerHeight;
    var by = Math.round(Math.pow(Math.random(), 1.7) * vh * 0.5);
    el.style.bottom = (by - 6) + "px";

    var obj = { el: el, body: body, img: img, targetX: targetX, state: "peek", timers: [], sweepTimer: null, dustTimer: null };
    nonnas.push(obj);

    setX(el, offX);
    // 1) peek in slowly from the edge with a little overshoot pop + a curious hold
    el.classList.add("is-peeking");
    raf2(function () {
      if (obj.state === "gone") { return; }
      el.style.transition = "transform 0.95s cubic-bezier(0.34, 1.42, 0.64, 1)";
      setX(el, peekX);
    });
    // 2) after a good beat, hop-walk in to the target spot
    obj.timers.push(setTimeout(function () {
      if (obj.state === "gone") { return; }
      obj.state = "walk";
      el.classList.remove("is-peeking");
      el.classList.add("is-walking");
      el.style.transition = "transform 1.5s linear";
      setX(el, targetX);
    }, 2000));
    // 3) settle and start sweeping
    obj.timers.push(setTimeout(function () {
      if (obj.state === "gone") { return; }
      startSweep(obj);
    }, 2000 + 1500));
  }

  function startSweep(obj) {
    obj.state = "sweep";
    obj.el.classList.remove("is-walking");
    obj.el.classList.add("is-sweeping");
    obj.el.style.transition = "none";
    // start on a random frame + vary the cadence a little so the nonnas aren't in sync
    var f = Math.floor(Math.random() * FRAMES.length);
    obj.img.src = FRAMES[f];
    var interval = 400 + Math.floor(Math.random() * 140); // 400-540ms, slow + deliberate
    obj.sweepTimer = setInterval(function () {
      f = (f + 1) % FRAMES.length;
      obj.img.src = FRAMES[f];
    }, interval);
    obj.dustTimer = setInterval(function () { puff(obj); }, 500);
    obj.timers.push(setTimeout(function () { puff(obj); }, 240));
  }

  // A small cloud: a few particles kicked up around the broom, staggered + varied.
  function puff(obj) {
    if (document.hidden || obj.state !== "sweep") { return; }
    var n = 3 + Math.floor(Math.random() * 3); // 3-5 particles
    for (var k = 0; k < n; k++) {
      var t = setTimeout(function () {
        if (obj.state !== "sweep") { return; }
        var d = document.createElement("span");
        d.className = "idle-dust";
        d.style.left = (16 + Math.random() * 64) + "%";
        d.style.bottom = Math.round(Math.random() * 14) + "px";
        d.style.setProperty("--dsize", Math.round(50 + Math.random() * 62) + "px");
        d.style.setProperty("--ddx", Math.round(Math.random() * 30 - 15) + "px");
        d.style.setProperty("--ddur", (0.8 + Math.random() * 0.5).toFixed(2) + "s");
        obj.el.appendChild(d);
        setTimeout(function () { if (d.parentNode) { d.parentNode.removeChild(d); } }, 1500);
      }, k * 65);
      obj.timers.push(t);
    }
  }

  function scatter() {
    if (!active) { return; }
    active = false;
    // cancel any nonnas still queued to trickle in
    spawnTimers.forEach(clearTimeout);
    spawnTimers = [];
    var vw = window.innerWidth;
    var list = nonnas;
    nonnas = [];
    list.forEach(function (obj) {
      // freeze immediately (stop sweeping + dust), then bolt after a short random beat
      obj.state = "gone";
      obj.timers.forEach(clearTimeout);
      if (obj.sweepTimer) { clearInterval(obj.sweepTimer); }
      if (obj.dustTimer) { clearInterval(obj.dustTimer); }
      var delay = Math.random() * 420; // quick cascade, all gone within ~0.6s
      setTimeout(function () { scatterOne(obj, vw); }, delay);
    });
  }

  function scatterOne(obj, vw) {
    obj.img.src = STANDING;
    obj.el.classList.remove("is-walking", "is-sweeping", "is-peeking");
    // "!" flash above the head + a startle jump
    var ex = document.createElement("span");
    ex.className = "idle-excl";
    ex.textContent = "!";
    obj.body.appendChild(ex);
    obj.el.classList.add("is-scatter");
    // dash off the nearest edge after a short startle beat
    var offX = obj.targetX < vw / 2 ? -260 : vw + 260;
    setTimeout(function () {
      obj.el.style.transition = "transform 0.5s cubic-bezier(0.45,-0.4,0.7,0.25)";
      setX(obj.el, offX);
    }, 190);
    var el = obj.el;
    setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 780);
  }

  var EVENTS = ["mousemove", "mousedown", "keydown", "wheel", "touchstart", "scroll"];
  function onActivity() { lastActivity = Date.now(); if (active) { scatter(); } }
  EVENTS.forEach(function (ev) { window.addEventListener(ev, onActivity, { passive: true }); });
  window.addEventListener("resize", function () { if (active) { scatter(); } });
  document.addEventListener("visibilitychange", function () {
    if (document.hidden && active) { scatter(); }
    lastActivity = Date.now();
  });

  setInterval(function () {
    if (!active && !document.hidden && (Date.now() - lastActivity) >= DELAY) { goIdle(); }
  }, 1000);
})();
